<template>
  <v-container fluid>
    <v-dialog v-model="InstallmentDetailStatus" fullscreen>
      <v-toolbar dark color="primary">
        <v-toolbar-title
          >Installment Details - {{ exam_code }} - {{ exam_year }} - Installment
          - {{ installment_no }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="close">Close</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card style="background-color: white;">
        <InstallmentDetails
          :installmentDialogStatus.sync="InstallmentDetailStatus"
        ></InstallmentDetails>
      </v-card>
    </v-dialog>
    <div>
      <v-container fluid>
        <v-card color="white">
          <formDialog
            :dialogStatus.sync="formDialogStatus"
            :indexEdited.sync="editedIndex"
          ></formDialog>

          <formDialogConfirm
            :dialogStatus.sync="confirmFormDialogStatus"
            :item.sync="item"
          ></formDialogConfirm>

          <v-layout row>
            <v-card flat>
              <v-card-text class="title">Payment Installment</v-card-text>
            </v-card>
            <v-divider class="my-2" vertical></v-divider>
            <v-text-field
              v-model="search"
              prepend-inner-icon="search"
              label="Search"
              class="mt-0"
              hide-details
              solo
              flat
              single-line
            ></v-text-field>
            <v-spacer />
            <v-btn color="primary" dark class="mb-2" @click="newItem"
              >New Item</v-btn
            >
            <v-btn small fab @click="getSearchApi()">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-layout>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="getSchema"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:items="props">
            <td class="justify-left  px-0">
              <div class="layout">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.execution_status == 1"
                      fab
                      small
                      color="#FF6D00"
                      @click="confirmDialogOpen(props.item)"
                      v-on="on"
                      style="color:#fff;"
                    >
                      <v-icon dark>send</v-icon>
                    </v-btn>
                  </template>
                  <span>Generate</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.execution_status == 0"
                      fab
                      small
                      color="info"
                      @click="agree(props.item.id)"
                      v-on="on"
                    >
                      <v-icon dark>cached</v-icon>
                    </v-btn>
                  </template>
                  <span>Reset</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="props.item.execution_status == 0"
                      fab
                      small
                      color="success"
                      @click="downloadPayment(props.item)"
                      v-on="on"
                    >
                      <v-icon dark>download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download</span>
                </v-tooltip>
                <v-tooltip
                  top
                  v-if="!props.item.rel_ff_payment_installment_details.length"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="primary"
                      @click="editItem(props.item)"
                      v-on="on"
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>

                <v-tooltip
                  right
                  v-if="props.item.rel_ff_payment_installment_details.length"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="blue"
                      @click="installmentDetailShow(props.item)"
                      v-on="on"
                    >
                      <v-icon dark>visibility</v-icon>
                    </v-btn>
                  </template>
                  <span>Show Details</span>
                </v-tooltip>
              </div>
            </td>
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-center">{{ props.item.no_of_installment }}</td>
            <td class="text-xs-center">
              {{ props.item.ff_start_date | dateFormat }}
            </td>
            <td class="text-xs-center">
              {{ props.item.ff_end_date | dateFormat }}
            </td>
            <td class="text-xs-center">
              {{ props.item.ff_form_fill_up_count }}
            </td>
            <td class="text-xs-center">
              {{ props.item.status === "1" ? "Active" : "Inactive" }}
            </td>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>

        <v-dialog v-model="resetDialog" persistent :max-width="options.width">
          <v-card style="border-radius:10px">
            <v-toolbar
              dark
              :color="options.color"
              class="my-tool pa-1"
              style
              flat
            >
              <v-spacer></v-spacer>
              <v-icon x-large style="font-size: 50px;">{{
                options.icon
              }}</v-icon>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="title pa-4 text-xs-center"
              >Are you sure that you want to reset Payment
              Installment?</v-card-text
            >
            <v-divider></v-divider>
            <v-card-actions class="pt-0 pb-0">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat text @click="resetPayment()">
                <div class="title text-xs-center">Yes</div>
              </v-btn>
              <v-spacer></v-spacer>
              <v-divider vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn color="primary" text flat large @click="cancel">
                <div class="title text-xs-center">Cancel</div>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </v-container>
</template>
<script>
import formDialog from "@/components/formFillup/admin/paymentInstallmentForm.vue";
import formDialogConfirm from "@/components/formFillup/admin/confirm.vue";
import InstallmentDetails from "@/components/formFillup/admin/paymentInstallmentDetails.vue";
export default {
  components: {
    formDialog,
    formDialogConfirm,
    InstallmentDetails,
  },
  data: () => ({
    installment_no: "",
    exam_code: "",
    exam_year: "",
    searchParam: {},
    InstallmentDetailStatus: false,
    formDialogStatus: false,
    installmentDialogStatus: false,
    confirmFormDialogStatus: false,
    confirm: false,
    search: "",
    item: {},
    resetDialog: false,
    options: {
      color: "primary",
      width: 490,
      icon: "warning",
      height: 500,
    },
    id:'',
    headers: [
      { text: "Actions", align: "center", value: "name", sortable: false },
      { text: "SL", align: "center", sortable: false, value: "index" },
      { text: "Title", align: "left", value: "title" },
      { text: "Inst.", align: "center", value: "no_of_installment" },
      { text: "C.C Start Date", align: "center", value: "ff_start_date" },
      { text: "C.C. Close Date", align: "center", value: "ff_end_date" },
      {
        text: "No. of Student",
        align: "center",
        value: "ff_form_fill_up_count",
      },
      { text: "status", align: "center", value: "status" },
    ],
    today: new Date().toISOString().slice(0, 10),
    editedIndex: -1,
  }),

  computed: {
    getSchema() {
      return this.$store.getters.getAllPaymentInstallment;
    },
    getLoggedInExam() {
      return this.$store.getters.getLoggedInExam;
    },
    getLoggedInYear() {
      return this.$store.getters.getLoggedInYear;
    },
    getExamInitiateId() {
      return this.$store.getters.getExamInitiateId;
    },
  },

  created() {
    this.getSearchApi();
  },

  methods: {
    dialogOpen() {
      this.formDialogStatus = true;
    },
    confirmDialogOpen(item) {
      this.item = item;
      this.confirmFormDialogStatus = true;
    },
    installmentDetailShow(item) {
      this.installment_no = item.no_of_installment;
      this.exam_code = item.exam_code;
      this.exam_year = item.exam_year;
      this.$store.commit(
        "SET_PAYMENT_INSTALLMENT_DETAILS_SCHEMA",
        item.rel_ff_payment_installment_details
      );
      this.InstallmentDetailStatus = true;
    },
    newItem() {
      this.editedIndex = -1;
      this.$store.commit(
        "UNSET_PAYMENT_INSTALLMENT_FORM_SCHEMA",
        this.searchParam
      );
      this.dialogOpen();
    },
    editItem(item) {
      this.$store.commit(
        "SET_PAYMENT_INSTALLMENT_FORM_SCHEMA",
        Object.assign({}, item)
      );
      this.editedIndex = this.getSchema.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.formDialogStatus = true;
    },
    getSearchApi() {
      this.initSearchParam();
      this.$store.dispatch("getAllPaymentInstallment", this.searchParam);
    },
    initSearchParam() {
      this.searchParam.exam_code = this.getLoggedInExam.code;
      this.searchParam.exam_year = this.getLoggedInYear.year;
      this.searchParam.exam_initiate_id = this.getExamInitiateId;
    },
    close() {
      this.$store.commit("UNSET_PAYMENT_INSTALLMENT_DETAILS_SCHEMA");
      this.InstallmentDetailStatus = false;
    },
    agree(id) {
      this.resetDialog = true;
      this.id = id
    },
    cancel() {
      this.resetDialog = false;
    },
    resetPayment() {
      console.log(this.id);
      this.$store.dispatch("resetPaymentInstallment", this.id).then((rsp) => {
        console.log(rsp);
        if (rsp.data.status === "success") {
          this.resetDialog = false;
          this.getSearchApi();
        }
      });
    },
    downloadPayment(item) {
      let params = {
        exam_code: item.exam_code,
        exam_year: item.exam_year,
        payment_installment_id: item.id,
        no_of_installment: item.no_of_installment,
      };
      console.log(params);

      this.$store
        .dispatch("downloadPaymentInstallment", params)
        .then(() => {
          if (this.$toast) this.$toast.success("File downloaded successfully!");
        })
        .catch(() => {
          if (this.$toast) this.$toast.error("Download failed!");
        });
    },
  },
  mounted() {
    this.initSearchParam();
    this.getSearchApi();
  },
};
</script>

<style scoped></style>
